import React, { useState } from "react";
import { css } from "emotion";
import { useNewOffer } from "../../../../context/new-offer";
import { stepContent, header, singleInput, offerMilesStyle, padding15TopBottom, bonusStyle } from "./../style";
import { currencyMask } from "../../../../../shared/create-offer/utils/masks";
import { formatCurrency, floatFormat } from "../../../../../shared/create-offer/utils/formats";
import Loading from "../../../../../shared/create-offer/Loading/Loading";
import InputForm from "../../../../../shared/atoms/InputForm";
import { ItemCardInfoRanking } from "../../../../../shared/create-offer/ItemsCardInfoFidelityProgramDetails";
import { useNewOfferMobile } from "../../context";
import MessageBar from "../../../../../shared/create-offer/MessageBar/MessageBar";
import mask from "../../../../shared/moneyMask";
import ArrowRight from "../../../../../shared/Arrows/ArrowRight";

// Debounce function
let timerId;
const debounced = (fn, delay = 250) => {
	if (timerId) clearTimeout(timerId);
	timerId = setTimeout(fn, delay);
};

const PriceMiles = ({ setModalDynamicRange, openModalDynamicBonus, bonusValid }) => {
	const { offerData, rankingData, pricesData, setOfferData } = useNewOffer();
	const { setStepError } = useNewOfferMobile();

	const { minPrice, maxPrice, valSuggestMin, valSuggestMax } = pricesData.data;

	const [valid, setValid] = useState(undefined);
	const [priceOfferMiles, setPriceOfferMiles] = useState(
		!!offerData.data.price && offerData.data.price !== "undefined" ? `R$ ${formatCurrency(offerData.data.price)}` : ""
	);

	const [errors, setErrors] = useState({
		priceOfferMiles:
			priceOfferMiles &&
			(floatFormat(priceOfferMiles) < minPrice || floatFormat(priceOfferMiles) > maxPrice)
	});

	const onChange = async (name, value) => {
		switch (name) {
			case "priceOfferMiles":
				let price = value.length ? floatFormat(value) : undefined;

				let priceOfferMilesIsValid = price >= minPrice && price <= maxPrice;

				setPriceOfferMiles(value);
				setErrors({
					...errors,
					priceOfferMiles: !priceOfferMilesIsValid
				});

				await setOfferData({
					data: {
						...offerData.data,
						price: formatCurrency(price),
						invalid: !priceOfferMilesIsValid
					}
				});
				break;
		}
	};

	let newValid = priceOfferMiles && !errors.priceOfferMiles;

	if (valid !== newValid) {
		setValid(newValid);
		setStepError(!newValid);
	}

	const blockOpenDynamicRange = false && (
		<div
			className="dynamic-range"
			onClick={() => setModalDynamicRange()}
			dataAction="dynamic-range-open"
		>
			<span className="dynamic-range--text">
				<strong>Quer cadastrar um valor maior?</strong>
			</span>
			<ArrowRight />
		</div>
	);

	const blockOpenDynamicBonus = bonusValid && (
		<div
			className={css`
				${bonusStyle};
			`}
			onClick={openModalDynamicBonus}
			dataAction="dynamic-bonus-open"
		>
			<div className="dynamic-bonus--text">
				<p>
					Bônus <span>Aproveite</span>
				</p>
			</div>
			<ArrowRight />
		</div>
	);

	const blockPrice = (
		<div>
			<div className="price-offer-miles">
				<div className="price-offer-miles--wrapper">
					<InputForm
						className="price-offer-miles--component"
						name="priceOfferMiles"
						id="priceOfferMiles"
						type="tel"
						value={priceOfferMiles}
						maxlength="8"
						onKeyUp={ev => {
							![8, 46, 37, 39].includes(ev.keyCode) &&
								ev.target.setSelectionRange(ev.target.value.length, ev.target.value.length);
						}}
						onChange={ev => {
							let val = ev.target.value;
							const { maskedValue } = mask(val, 2, ",", ".", false, "R$ ");
							setPriceOfferMiles(maskedValue);
							debounced(() => onChange("priceOfferMiles", maskedValue), 300);
						}}
						placeholder=""
						label="Valor a cada 1.000 milhas"
						guide={false}
						hasError={errors.priceOfferMiles}
						errorMessage={`O valor precisa estar entre ${formatCurrency(
							minPrice
						)} e ${formatCurrency(maxPrice)}`}
						data-action="simulator-miles-price"
					/>
				</div>
				{rankingData.isFetching || pricesData.isFetching ? (
					<div className="price-offer-miles--loading">
						<Loading width={36} height={36} />
					</div>
				) : (
					<span className="price-offer-miles--text">
						Sugerido entre&nbsp;
						<span>R$ {formatCurrency(valSuggestMin)}</span> e&nbsp;
						<span>R$ {formatCurrency(valSuggestMax)}</span>
					</span>
				)}
			</div>
		</div>
	);

	return (
		<div
			className={css`
				${stepContent};
			`}
			style={{ minHeight: "350px" }}
		>
			<strong
				className={css`
					${header};
				`}
			>
				Oferta de milhas
			</strong>
			<div
				className={css`
					${singleInput};
				`}
			>
				<div
					className={css`
						${offerMilesStyle}
					`}
				>
					{blockPrice}
					{blockOpenDynamicRange}
					{blockOpenDynamicBonus}
				</div>

				<div
					className={css`
						${padding15TopBottom};
					`}
				>
					<ItemCardInfoRanking mobile={true} />
				</div>

				<MessageBar />
			</div>
		</div>
	);
};

export default PriceMiles;
